import { INPUT_TYPE } from "../../summary-employee-request/constant";
import { department } from "../../../info-technology-process/data";

export const formFields1 = [
  {
    type: INPUT_TYPE.TEXT,
    label: "Họ và tên",
    require: true,
    field: "eFullName",
    placeholder: "Nhập họ và tên",
    span: 8,
  },
  {
    type: INPUT_TYPE.SELECT,
    options: department,
    label: "Cơ quan/Đơn vị",
    require: true,
    field: "eDepartment",
    span: 8,
    placeholder: "Chọn Cơ quan/Đơn vị",
  },
  // {
  //   type: INPUT_TYPE.SELECT,
  //   options: [],
  //   label: "Đơn vị thuộc chi nhánh",
  //   require: true,
  //   field: "eUnit",
  //   span: 8,
  //   placeholder: "Chọn đơn vị",
  // },
];

export const formFields2 = [
  {
    type: INPUT_TYPE.TEXT,
    label: "Thành phần dự họp",
    require: true,
    field: "eMeetingParticipants",
    placeholder: "Nhập thành phần dự họp",
    span: 8,
  },
  {
    type: INPUT_TYPE.TEXT,
    options: department,
    label: "Số lượng tham gia",
    require: true,
    field: "eNumberParticipants",
    span: 8,
    placeholder: "Nhập số lượng tham gia",
  },
  {
    type: INPUT_TYPE.DATE_TIME,
    label: "Thời gian tổ chức",
    require: true,
    field: "eMeetingTime",
    span: 8,
    placeholder: "Chọn thời gian tổ chức",
  },
  {
    type: INPUT_TYPE.TEXT_AREA,
    label: "Mục đích cuộc họp",
    require: true,
    field: "eMeetingPurpose",
    span: 24,
    rows:5,
    placeholder: "Nhập mục đích cuộc họp",
  },
];
